(() => {
  'use strict';
  if (window.tfContentShopBound || !/^\/blogs\/[^/]+\/[^/]+\/?$/.test(location.pathname)) return;
  window.tfContentShopBound = true;
  const query = new URLSearchParams(location.search);
  const excluded = () => {
    if (window.Shopify?.designMode || window.Shopify?.previewMode || query.has('preview_theme_id') || query.has('preview_key') || query.has('tf_audit')) return true;
    if (/^https:\/\/(admin\.shopify\.com|[^/]+\.myshopify\.com)(\/|$)/i.test(document.referrer)) return true;
    try { return localStorage.getItem('tf_internal') === '1'; } catch (_) { return false; }
  };
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  if (!window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], () => {});
  }
  const targetId = () => {
    const ids = new Set();
    for (const entry of window.dataLayer || []) {
      if (entry?.[0] === 'config' && /^G-[A-Z0-9]+$/.test(entry[1])) ids.add(entry[1]);
    }
    // Do not guess a destination when the store has multiple GA4 configurations.
    return ids.size === 1 ? [...ids][0] : null;
  };
  const handled = new WeakSet();
  const record = event => {
    if (handled.has(event) || event.defaultPrevented || excluded() || !allowed() || typeof window.gtag !== 'function') return;
    if ((event.type === 'click' && event.button !== 0) || (event.type === 'auxclick' && event.button !== 1)) return;
    const anchor = event.target instanceof Element ? event.target.closest('a[href]') : null;
    if (!anchor || !anchor.closest('main') || anchor.closest('nav,header,footer,[role="navigation"]') || anchor.hasAttribute('download')) return;
    let url;
    try { url = new URL(anchor.href, location.origin); } catch (_) { return; }
    if (url.origin !== location.origin || !/^\/(products|collections)\/[^/]+\/?$/.test(url.pathname)) return;
    const sendTo = targetId();
    if (!sendTo) return;
    handled.add(event);
    const placement = anchor.closest('.tfbl-cta') ? 'footer' : anchor.closest('.tfbl-product') ? 'product_card' : anchor.closest('.tfbl-callout,.tfbl-reality') ? 'callout' : 'body';
    window.gtag('event', 'content_shop_click', {
      send_to: sendTo,
      source_path: location.pathname,
      destination_path: url.pathname,
      destination_type: url.pathname.startsWith('/products/') ? 'product' : 'collection',
      placement,
      content_topic: location.pathname.split('/').filter(Boolean).pop(),
      transport_type: 'beacon'
    });
  };
  document.addEventListener('click', record);
  document.addEventListener('auxclick', record);
})();
